/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { useEffect, useRef, useState, useCallback, createRef } from 'react'
import { Form, Card, Col, Image, Skeleton, Descriptions, Layout, Row, Button, Tag, Select } from 'antd'
import PropTypes from 'prop-types'
import { PrinterOutlined, StopOutlined, CheckOutlined, ClockCircleOutlined, FileDoneOutlined, EditOutlined, RightOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { useLocation } from 'react-router-dom'
import { DefaultLayout } from 'src/layouts/default'
import { connect } from 'react-redux'
import { Gap } from 'src/components/atoms/Gap'

import printJS from 'print-js'
import { useReactToPrint } from 'react-to-print'
// import PrintGenerate from './PrintGenerate'
import LayoutA4QR10x10 from 'src/pages/generates-qr/layout-print/a4/QR10x10'
import LayoutA4QR20x20 from 'src/pages/generates-qr/layout-print/a4/QR20x20'
import LayoutA4QR10x10Text from 'src/pages/generates-qr/layout-print/a4/QR10x10-text'
import LayoutSample from 'src/pages/generates-qr/layout-print/a4/sample'

import LayoutA41of1QR20x20 from 'src/pages/generates-qr/layout-print/a4/1of1-20x20'
import LayoutA41of1QR30x30 from 'src/pages/generates-qr/layout-print/a4/1of1-30x30'
import LayoutA41of1QR40x40 from 'src/pages/generates-qr/layout-print/a4/1of1-40x40'

import LayoutA41of1QR20x20Text from 'src/pages/generates-qr/layout-print/a4/1of1-20x20-text'
import LayoutA41of1QR40x40Text from 'src/pages/generates-qr/layout-print/a4/1of1-40x40-text'

import Layout40x20WhitoutText from 'src/pages/generates-qr/layout-print/a3/QRContainer40x20WhitoutText'

import LayoutA3QRCont40x20 from 'src/pages/generates-qr/layout-print/a3/QRContainer40x20'
import LayoutA3QR20x20 from 'src/pages/generates-qr/layout-print/a3/QR20x20'
import LayoutA3QR10x10 from 'src/pages/generates-qr/layout-print/a3/QR10x10'
import LayoutA310x10Text from 'src/pages/generates-qr/layout-print/a3/QR10x10-text'

import LayoutA0QR10x10Text from 'src/pages/generates-qr/layout-print/a0/QRContainer10x10Text'
// import styles from './styles/a3-layout-40x20.module.css'
import { FormItem } from 'src/components/molecules/FormItem'
import { PreviewMap } from './PreviewMap'
import './style/index.css'
import { GeneratePrintCetakan } from './GeneratePrintCetakan'

export const _PreviewGenerateOpim = ({ token, dispatch, detailPrint, loading }) => {
  const { state } = useLocation()
  const [form] = Form.useForm()
  const componentRef = useRef()
  const printRef = createRef()
  // const [printRef, setPrintRef] = useState(null)

  const [printLoading, setPrintLoading] = useState(0)
  const [printPercetakanLoading, setPrintPercetakanLoading] = useState(0)
  const [detailGenerate, setDetailGenerate] = useState()
  const [edit, setEdit] = useState(false)
  const [visible, setVisible] = useState(false)

  const cssPageMedia = (size = '210mm 297mm') => {
    let style
    const [pageWitdh, pageHeight] = size.split(' ')

    if (!document.getElementById('page-size')) {
      style = document.createElement('style')
      // style.setAttribute('id', 'page-size')
      document.head.append(style)
    } else {
      style = document.getElementById('page-size')
    }
    style.innerHTML = `\n
      @page {
        size: ${size};
      }\n
      @media print {\n
        html, body {\n
          width: ${pageWitdh};
          height: ${pageHeight};
        }\n
        @page {\n
          margin: 5.5mm 7.5mm;
        }\n
        
      }\n
      `
  }

  useEffect(() => {
    dispatch({
      type: 'print/get_one_print',
      payload: {
        token,
        printRequestId: state
      }
    })
  }, [])

  useEffect(() => {
    detailPrint && getDetailGenerate(detailPrint)
    if (detailPrint) {
      const newData = {
        ...form,
        expedition: detailPrint.expedition,
        receipt: detailPrint.noReceipt
      }

      form.setFieldsValue(newData)
    }
  }, [detailPrint])

  // useEffect(() => {
  //   loading && form.resetFields()
  // }, [loading])

  const formatDate = (dateFormat) => {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]
    const dated = new Date(dateFormat)
    const dateNumber = dated.getDate()
    const month = monthNames[dated.getMonth()]
    const year = dated.getFullYear()

    return `${dateNumber} ${month} ${year}`
  }

  detailGenerate?.expiredAt && formatDate(detailGenerate?.expiredAt)

  const getDetailGenerate = (val) => {
    const datas = val.generateQrcode
    const qrcodes = datas.qrcodes
    if (qrcodes) {
      datas.qrcodes = qrcodes.sort((a, b) => Number(a.sku.substring(a.sku.indexOf('-') + 1, a.sku.lastIndexOf('-'))) - Number(b.sku.substring(b.sku.indexOf('-') + 1, b.sku.lastIndexOf('-'))))
    }
    setDetailGenerate(datas)
    setLayoutPrint(val.generateQrcode?.size)
  }

  const setLayoutPrint = (size) => {
    const settingSize = size

    switch (settingSize) {
      case 'SMALL':
        cssPageMedia()
        break

      case 'A4_10x10_TEXT':
        cssPageMedia()
        break

      case 'A4_1_FOR_1_PAGE_QR_20x20':
        cssPageMedia()
        break

      case 'A4_1_FOR_1_PAGE_QR_30x30':
        cssPageMedia()
        break

      case 'A4_1_FOR_1_PAGE_QR_40x40':
        cssPageMedia()
        break

      case 'A4_1_FOR_1_PAGE_QR_20x20_TEXT':
        cssPageMedia()
        break

      case 'A4_1_FOR_1_PAGE_QR_40x40_TEXT':
        cssPageMedia()
        break

      case 'A3_10x10':
        cssPageMedia('297mm 420mm')
        break

      case 'A3_10x10_TEXT':
        cssPageMedia('297mm 420mm')
        break

      case 'MEDIUM':
        cssPageMedia('297mm 420mm')
        break

      case 'LARGE':
        cssPageMedia('297mm 420mm')
        break

      case 'A0_10x10_TEXT':
        cssPageMedia('9933px 14043px')
        break

      default:
        cssPageMedia()
        break
    }
  }

  const PagePrint = () => {
    const settingSize = detailGenerate?.size
    let printPage = ''

    switch (settingSize) {
      case 'SMALL':
        printPage = <LayoutA4QR10x10 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'A4_10x10_TEXT':
        if (detailGenerate?.textInQrcode === '') {
          printPage = <LayoutA4QR10x10 ref={componentRef} data={detailGenerate?.qrcodes} />
        } else {
          printPage = <LayoutA4QR10x10Text ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        }
        break

      case 'A4_1_FOR_1_PAGE_QR_20x20':
        printPage = <LayoutA41of1QR20x20 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'A4_1_FOR_1_PAGE_QR_30x30':
        printPage = <LayoutA41of1QR30x30 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'A4_1_FOR_1_PAGE_QR_40x40':
        printPage = <LayoutA41of1QR40x40 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'A4_1_FOR_1_PAGE_QR_20x20_TEXT':
        printPage = <LayoutA41of1QR20x20Text ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        break

      case 'A4_1_FOR_1_PAGE_QR_40x40_TEXT':
        printPage = <LayoutA41of1QR40x40Text ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        break

      case 'A3_10x10_TEXT':
        if (detailGenerate?.textInQrcode === '') {
          printPage = <LayoutA3QR10x10 ref={componentRef} data={detailGenerate?.qrcodes} />
        } else {
          printPage = <LayoutA310x10Text ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        }
        break

      case 'MEDIUM':
        if (detailGenerate?.textInQrcode === '') {
          printPage = <Layout40x20WhitoutText ref={componentRef} data={detailGenerate?.qrcodes} />
        } else {
          printPage = <LayoutA3QRCont40x20 ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        }
        break

      case 'a4_1of1_page_qr_20x20':
        printPage = <LayoutA41of1QR20x20 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'A3_10x10':
        printPage = <LayoutA3QR10x10 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'LARGE':
        printPage = <LayoutA3QR20x20 ref={componentRef} data={detailGenerate?.qrcodes} />
        break

      case 'A0_10x10_TEXT':
        printPage = <LayoutA0QR10x10Text ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        break

      default:
        printPage = <LayoutSample ref={componentRef} data={detailGenerate?.qrcodes} textInQrcode={detailGenerate?.textInQrcode} />
        break
    }
    return printPage
  }

  const handleBeforePrint = useCallback(() => {
    setPrintLoading(0)
  }, [setPrintLoading])

  const handlePrintingonBeforeGetContent = useCallback(() => {
    setPrintLoading(1)
    // cssPageMedia('A3')
  }, [setPrintLoading])

  const handleBeforePrintPercetekan = useCallback(() => {
    setPrintPercetakanLoading(0)
  }, [setPrintPercetakanLoading])

  const handlePrintingPercetakanonBeforeGetContent = useCallback(() => {
    setPrintPercetakanLoading(1)
    // cssPageMedia('A3')
  }, [setPrintPercetakanLoading])

  const reactToPrintContent = useCallback(() => {
    return componentRef.current
  }, [componentRef.current])

  const onHandlePrint = useReactToPrint({
    content: reactToPrintContent,
    suppressErrors: true,
    onBeforeGetContent: handlePrintingonBeforeGetContent,
    onBeforePrint: handleBeforePrint
    // pageStyle: printPageStyle
  })

  // const onHandlePrintCetakan = () => {
  //   setPrintRef(createRef())
  // }

  const onHandlePrintCetakan = useReactToPrint({
    content: () => printRef.current,
    suppressErrors: true,
    onBeforeGetContent: handlePrintingPercetakanonBeforeGetContent,
    onBeforePrint: handleBeforePrintPercetekan
    // pageStyle: printPageStyle
  })

  const onHandlePrintForPrintJS = () => {
    printJS({
      modalMessage: 'Printing QR...',
      printable: 'paper',
      type: 'html',
      showModal: true,
      css: './styles/a3-layout-40x20.module.css',
      font_size: 5
      // imageStyle: 'width: 14.5mm; height: 14.5mm; float: left;',
      // gridStyle: 'margin:0; padding:0'
    })
  }

  const onSubmit = () => {
    form.validateFields().then(data => {
      const newData = {
        noReceipt: data.receipt,
        expedition: data.expedition
      }

      dispatch({
        type: 'print/update_print',
        payload: {
          token,
          printRequestId: state,
          data: JSON.stringify(newData)
        }
      })
    })
    setEdit(!edit)
  }

  const onSelect = (val) => {
    const newData = {
      status: val
    }
    dispatch({
      type: 'print/update_print',
      payload: {
        token,
        printRequestId: state,
        data: JSON.stringify(newData)
      }
    })
  }

  const extra = (
    <div className='d-flex'>
      <Button className='mr-2' loading={printPercetakanLoading} onClick={onHandlePrintCetakan} type='primary' block icon={<PrinterOutlined />} style={{ backgroundColor: '#293AB4', borderColor: '#293AB4' }}>Print untuk Cetakan</Button>
      <Button className='mr-2' loading={printLoading} onClick={onHandlePrint} type='primary' block icon={<PrinterOutlined />} style={{ backgroundColor: '#293AB4', borderColor: '#293AB4' }}>Print</Button>
      <Button loading={printLoading} onClick={() => setEdit(!edit)} type='primary' block icon={!edit ? <EditOutlined /> : <CloseCircleOutlined />} style={{ backgroundColor: '#293AB4', borderColor: '#293AB4' }}>{!edit ? 'Edit' : 'Cancel'}</Button>
    </div>
  )

  const getTitleLayoutPrint = (layoutPrint) => {
    let title
    switch (layoutPrint) {
      case 'SMALL':
        title = 'A4 : QR Code Size 10x10mm'
        break

      case 'A4_1_FOR_1_PAGE_QR_20x20':
        title = 'A4 : A4 : 1 QR Code for 1 Page - QR Code Size 20x20mm'
        break

      case 'A4_1_FOR_1_PAGE_QR_30x30':
        title = 'A4 : A4 : 1 QR Code for 1 Page - QR Code Size 30x30mm'
        break

      case 'A4_1_FOR_1_PAGE_QR_40x40':
        title = 'A4 : A4 : 1 QR Code for 1 Page - QR Code Size 30x30mm'
        break

      case 'A4_1_FOR_1_PAGE_QR_20x20_TEXT':
        title = 'A4 : A4 : 1 QR Code for 1 Page - QR Code Size 20x20mm with Text'
        break

      case 'A4_1_FOR_1_PAGE_QR_40x40_TEXT':
        title = 'A4 : A4 : 1 QR Code for 1 Page - QR Code Size 40x40mm with Text'
        break

      case 'MEDIUM':
        title = 'A3 : QR Code SIze 20x20mm with Text'
        break

      case 'LARGE':
        title = 'A3 : QR Code Size 20x20mm'
        break

      case 'A3_10x10':
        title = 'A3 : QR Code Size 10x10mm'
        break

      case 'A3_10x10_TEXT':
        title = 'A3 : QR Code Size 10x10mm with Text'
        break

      case 'A0_10x10_TEXT':
        title = 'A0 : QR Code Size 10x10mm with Text'
        break

      default:
        title = layoutPrint
        break
    }

    return title
  }

  return (
    <DefaultLayout>
      <Layout.Content className='container-detail-product'>
        <Card>
          <Descriptions
            column={2}
            title='Detail QR'
            extra={extra}
          >
            <Descriptions.Item label='Status'>
              <Skeleton loading={loading}>
                {detailGenerate?.status === 'GENERATED'
                  ? <Tag color='green'>{detailGenerate?.status}</Tag>
                  : <Tag color='orange'>{detailGenerate?.status}</Tag>}
              </Skeleton>
            </Descriptions.Item>
            <Descriptions.Item label='Production Date'>
              <Skeleton loading={loading}>
                {/* {detailGenerate?.productionDate} */}
                {formatDate(detailGenerate?.productionDate)}
              </Skeleton>
            </Descriptions.Item>
            <Descriptions.Item label='Total'>
              <Skeleton loading={loading}>
                {detailGenerate?.total}
              </Skeleton>
            </Descriptions.Item>
            <Descriptions.Item label='Expired Date'>
              <Skeleton loading={loading}>
                {/* {detailGenerate?.expiredAt} */}
                {detailGenerate?.expiredAt ? formatDate(detailGenerate?.expiredAt) : '-'}
              </Skeleton>
            </Descriptions.Item>
            <Descriptions.Item label='ID Generate QR Code'>
              <Skeleton loading={loading}>
                {detailGenerate?.customId ? detailGenerate.customId : detailGenerate?.id}
              </Skeleton>
            </Descriptions.Item>
            <Descriptions.Item label='QR Size'>
              <Skeleton loading={loading}>
                {getTitleLayoutPrint(detailGenerate?.size)}
              </Skeleton>
            </Descriptions.Item>
            <Descriptions.Item label='Print Status'>
              <Skeleton loading={loading}>
                <Select
                  placeholder='Select a option and change input text above'
                  // onChange={this.onGenderChange}
                  defaultValue='NOT_PRINTED'
                  style={{
                    width: 140
                  }}
                  value={detailPrint?.status}
                  onSelect={onSelect}
                >
                  <Select.Option value='NOT_PRINTED'>
                    <div className='d-flex' style={{ alignItems: 'center' }}>
                      <StopOutlined className='mr-2' style={{ color: '#EB5757' }} /> Not Printed
                    </div>
                  </Select.Option>
                  <Select.Option value='IN_QUEUE'>
                    <div className='d-flex' style={{ alignItems: 'center' }}>
                      <ClockCircleOutlined className='mr-2' style={{ color: '#F2994A' }} /> In Queue
                    </div>
                  </Select.Option>
                  <Select.Option value='PRINTED'>
                    <div className='d-flex' style={{ alignItems: 'center' }}>
                      <CheckOutlined className='mr-2' style={{ color: '#27AE60' }} /> Printed
                    </div>
                  </Select.Option>
                  <Select.Option value='DELIVERING'>
                    <div className='d-flex' style={{ alignItems: 'center' }}>
                      <svg className='mr-2' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M13.3334 11.333H14.6667V9.10634C14.667 8.75605 14.5982 8.40913 14.4644 8.08541C14.3306 7.76169 14.1343 7.46751 13.8867 7.21967L12.6667 5.99967H9.33337V11.333H10M6.66671 11.333H9.33337V3.33301H1.33337V11.333H3.33337H6.66671Z' stroke='#21BADF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                        <path d='M5.00004 13.3333C5.92052 13.3333 6.66671 12.5871 6.66671 11.6667C6.66671 10.7462 5.92052 10 5.00004 10C4.07957 10 3.33337 10.7462 3.33337 11.6667C3.33337 12.5871 4.07957 13.3333 5.00004 13.3333Z' stroke='#21BADF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                        <path d='M11.6667 13.3333C12.5871 13.3333 13.3333 12.5871 13.3333 11.6667C13.3333 10.7462 12.5871 10 11.6667 10C10.7462 10 10 10.7462 10 11.6667C10 12.5871 10.7462 13.3333 11.6667 13.3333Z' stroke='#21BADF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                      Delivering
                    </div>
                  </Select.Option>
                  <Select.Option value='RECEIVED'>
                    <div className='d-flex' style={{ alignItems: 'center' }}>
                      <FileDoneOutlined className='mr-2' style={{ color: '#27AE60' }} /> Received
                    </div>
                  </Select.Option>
                </Select>
              </Skeleton>
            </Descriptions.Item>
          </Descriptions>

          <Form form={form} layout='vertical' className='mb-5'>
            <Row id='print-by-opim'>
              <Col span={12}>
                <Skeleton loading={loading}>
                  <FormItem
                    label='Add Receipt Number'
                    placeholder='Receipt Number'
                    name='receipt'
                    disabled={!edit}
                  />
                </Skeleton>
                <Skeleton loading={loading}>
                  <FormItem
                    label='Expedition'
                    placeholder='Add Expedition'
                    name='expedition'
                    disabled={!edit}
                  />
                </Skeleton>
                {edit && <Button ghost type='primary' onClick={onSubmit}>Update</Button>}
              </Col>
              <Col span={12}>
                <Skeleton loading={loading}>
                  <label className='mb-2'>Address</label>
                  <div className='address' onClick={() => setVisible(!visible)}>
                    <h3 className='d-flex address-title' style={{ alignItems: 'center' }}>{detailPrint?.address.address} <span className='ml-1' style={{ fontSize: 11, fontWeight: 500 }}>({detailPrint?.address.phone.indexOf('0') === 0 ? detailPrint?.address.phone.replace('0', '+62') : detailPrint?.address.phone})</span></h3>
                    <div className='d-flex'>
                      {detailPrint?.address.address}, {detailPrint?.address.city}, {detailPrint?.address.district}, {detailPrint?.address.province}, ID {detailPrint?.address.zip}
                      <div style={{ textAlign: 'right' }}>
                        <RightOutlined style={{ fontSize: 13, color: '#828282' }} />
                      </div>
                    </div>
                    {detailPrint?.address.description && (
                      <div className='address-description p-2 mt-2'>
                        {detailPrint?.address.description}
                      </div>
                    )}
                  </div>
                </Skeleton>
              </Col>
            </Row>
          </Form>

          <Row gutter={16}>
            <Col md={24}>
              <p>Distros :</p>
              <Row gutter={16}>
                {
                detailGenerate?.distros.map((item, index) =>
                  <Col md={7} key={index}>
                    <Card loading={loading} hoverable style={{ fontSize: 11 }}>
                      <div className='d-flex'>
                        <div style={{ width: '30%' }}>
                          Name
                        </div>
                        <div style={{ width: '5%' }}>
                          :
                        </div>
                        <div style={{ width: '65%', fontWeight: 600 }}>
                          {item.name}
                        </div>
                      </div>
                      <Gap height='.4rem' />
                      <div className='d-flex'>
                        <div style={{ width: '30%' }}>
                          Owner
                        </div>
                        <div style={{ width: '5%' }}>
                          :
                        </div>
                        <div style={{ width: '65%', fontWeight: 600 }}>
                          {item.owner}
                        </div>
                      </div>
                      <Gap height='.4rem' />
                      <div className='d-flex'>
                        <div style={{ width: '30%' }}>
                          Code
                        </div>
                        <div style={{ width: '5%' }}>
                          :
                        </div>
                        <div style={{ width: '65%', fontWeight: 600 }}>
                          {item.code}
                        </div>
                      </div>
                      <Gap height='.4rem' />
                      <div className='d-flex'>
                        <div style={{ width: '30%' }}>
                          Address
                        </div>
                        <div style={{ width: '5%' }}>
                          :
                        </div>
                        <div style={{ width: '65%', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {item.address}
                        </div>
                      </div>
                      <Gap height='.4rem' />
                      <div className='d-flex'>
                        <div style={{ width: '30%' }}>
                          Created At
                        </div>
                        <div style={{ width: '5%' }}>
                          :
                        </div>
                        <div style={{ width: '65%', fontWeight: 600 }}>
                          {item.createdAt}
                        </div>
                      </div>
                    </Card>
                    <Gap height='1em' />
                  </Col>
                )
              }
              </Row>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={24}>
              <p>QRCodes :</p>
              <Row gutter={12}>
                {
                  detailGenerate?.qrcodes.map((item, index) =>
                    <Skeleton key={index} loading={loading}>
                      <Col md={4}>
                        <Card
                          hoverable
                          style={{ padding: 1 }}
                          cover={
                            <Image
                              key={index}
                              src={item?.url}
                            />
                        }
                          bodyStyle={{ padding: 12 }}
                        >
                          <Card.Meta
                            // title={(detailGenerate.expiredAt && item?.limitCheck) ? item?.uniqueCode : ''}
                            title={item?.uniqueCode ? item?.uniqueCode : ''}
                            description={[
                              <Row key='1' justify='space-between'>
                                <p style={{ margin: 0, fontSize: '.8rem', width: '100%' }}>{item?.sku}</p>
                                <p style={{ margin: 0, fontSize: '.8rem' }}>Total: {item?.totalChecked}</p>
                                <p style={{ margin: 0, fontSize: '.8rem' }}>Limit: {item?.limitCheck}</p>
                              </Row>
                            ]}
                          />
                        </Card>
                        <Gap height='1rem' />
                      </Col>
                    </Skeleton>
                  )
                }
              </Row>
            </Col>
          </Row>
        </Card>
        <PreviewMap
          visible={visible}
          detailPrint={detailPrint}
          onClose={() => setVisible(!visible)}
        />
      </Layout.Content>
      <div style={{ display: 'none' }}>
        {/* <PrintGenerate ref={(el) => (componentRef = el)} data={detailGenerate?.qrcodes} /> */}
        <PagePrint />
        <GeneratePrintCetakan detailGenerate={detailGenerate} ref={printRef} />
      </div>
    </DefaultLayout>
  )
}

const mapStateToProps = ({ reducerPrintRequest }) => {
  return { ...reducerPrintRequest }
}

export const PreviewGenerateOpim = connect(mapStateToProps)(_PreviewGenerateOpim)

_PreviewGenerateOpim.propTypes = {
  token: PropTypes.string,
  loading: PropTypes.bool,
  detailPrint: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array]),
  dispatch: PropTypes.func
}
